export default [
    {
      path: '/devis',
      name: 'projets-list',
      component: () => import('@/views/projets/Lists.vue'),
    },
    {
        path: '/devis/{id}',
        name: 'projets-details',
        component: () => import('@/views/projets/Details.vue'),
    },
    {
        path: '/devis',
        name: 'projets-proposition',
        component: () => import('@/views/projets/AddNewProjet.vue'),
    },
    {
        path: '/devis/proposition/:id',
        name: 'projets-proposition',
        component: () => import('@/views/projets/AddNewProjet.vue'),
    },
    {
        path: '/devis/souscription/:id',
        name: 'projets-souscription',
        component: () => import('@/views/projets/SouscriptionProjetGlobal.vue'),
    },
    {
        path: '/devis/notifier',
        name: 'projets-notifier',
        component: () => import('@/views/projets/Notification/NotifierProjet.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        },
    },
    {
        path: '/devis/historisationSolliciter/:id',
        name: 'projets-solliciter',
        component: () => import('@/views/projets/Notification/SolliciterProjet.vue'),
        meta: {
            layout: 'full',
        },
    },

  ]
  